/**
 * Default checklist automation rules
 * Maps checklist numbers (checkListNum) to progress stages (0-6)
 * These are the default rules that match the hardcoded logic in OnboardingSteps.tsx
 */

export interface ChecklistAutomationRule {
  check_list_num: string;
  progress: number;
  stage_label: string;
}

// Default automation rules (matches current hardcoded logic)
export const defaultChecklistAutomationRules: ChecklistAutomationRule[] = [
  { check_list_num: '1', progress: 0, stage_label: 'Invitation Sent' },
  { check_list_num: '2', progress: 2, stage_label: 'Enrolled in Course' },
  { check_list_num: '3', progress: 3, stage_label: 'Passed the Test Waiting License Approval' },
  { check_list_num: '4', progress: 4, stage_label: 'Company Onboarding Waiting Agent Number Approval' },
  { check_list_num: '9', progress: 5, stage_label: 'Company Onboarding Agent Number Approved' },
  { check_list_num: '14', progress: 6, stage_label: 'Agent Number Approved Waiting for Training' },
];

/**
 * Get default automation rules
 */
export const getDefaultAutomationRules = (): ChecklistAutomationRule[] => {
  return defaultChecklistAutomationRules;
};

